import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { TelModuleStatusListFeatureGate } from '../Guards/TelModuleStatusListFeatureGate'
import { TelModuleStatusList } from '../Components/Organisms/TelModuleStatusList/TelModuleStatusList'

/**
 * Routed telephone module status page.
 */
@Route(RouteID.TEL_MODULE_STATUS)
export class TelModuleStatusListPage extends Component {
    /**
     * Renders the telephone module status page content tree.
     *
     * @returns Telephone module status page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.TEL_MODULE_STATUS}>
                <TelModuleStatusListFeatureGate>
                    <LanguageContextProvider>
                        <TelModuleStatusList />
                    </LanguageContextProvider>
                </TelModuleStatusListFeatureGate>
            </RouteGuard>
        )
    }
}
